import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// SPA PC 中后台项目性能监控上报
import { setPageIdObj } from "../utils/common";
import { createInstance } from "./core";

/* Todo：
一、 seesionid  

二、
1. web-vitals 
2. longtask  \  networkping \ inp  \ memory \
3  uid=username_code

*/

var defaultOpt = {
  fromType: "pc",
  enabledWebVitals: true,
  enabledLongTask: true,
  enableNetworkPing: true,
  enabledMemory: true,
  enabledRerenderEvent: true,
  uid: '',
  enabledLocationChange: true,
  enablePageLoad: true,
  topPageid: '',
  // todo: 父级 iframe 的 pageid, 在 iframe 环境内时内才会加到 backup 里
  beforeSend: function beforeSend(_) {
    // console.log('beforeSend', _)
  },
  getPageInfoLazy: false,
  enableInitTestLegoSend: false,
  needPathName: true,
  longtaskDurationThreshold: 250,
  // longtask 阈值  建议 200 ~ 300
  memoryInterval: 1000 * 60,
  // memory 阈值  默认 60 s
  rerenderEventDurationThreshold: 250,
  // rerender event 阈值  建议 200 ~ 300
  networkPingInterval: 1000 * 60 // network ping 间隔  默认 60 s
};
//
var legoPerfPc = function legoPerfPc() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpt;
  try {
    // 全局 ctx
    if (typeof window !== 'undefined') {
      var _window, _window2;
      var _options = Object.assign({}, defaultOpt, _objectSpread({}, options));
      // console.log('legoPerfPC', !window?.performance?.now)
      if (!((_window = window) !== null && _window !== void 0 && (_window = _window.performance) !== null && _window !== void 0 && _window.now) && !((_window2 = window) !== null && _window2 !== void 0 && _window2.PerformanceObserver)) return;
      if (_options.routeList) setPageIdObj(_options.routeList);
      var ctx = createInstance(_options);
      return ctx;
    }
  } catch (err) {
    console.error(err);
  }
};

// 
{
  var _uid = '';
  legoPerfPc.setuid = function (uid) {
    _uid = uid;
  };
  legoPerfPc.getuid = function () {
    return _uid;
  };
}
export default legoPerfPc;